import { render, staticRenderFns } from "./TechExpertUser.vue?vue&type=template&id=cb4589e0&scoped=true"
import script from "./TechExpertUser.vue?vue&type=script&lang=js"
export * from "./TechExpertUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4589e0",
  null
  
)

export default component.exports